import { render, staticRenderFns } from "./ForCompanies.vue?vue&type=template&id=6a55b536&"
import script from "./ForCompanies.vue?vue&type=script&lang=js&"
export * from "./ForCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports